import { Flex, Icon, IconButton, Input, Select, Text } from '@chakra-ui/react';
import { Table as ReactTable } from '@tanstack/react-table';
import { BiChevronLeft, BiChevronRight, BiChevronsLeft, BiChevronsRight, BiX } from 'react-icons/bi';

import { MIN_PAGE_SIZE } from '../../constants';

export const Pagination = <T,>({ table, totalItems }: { table: ReactTable<T>; totalItems?: number }) => {
    const itemCount = totalItems || table.getFilteredRowModel().rows.length;
    const pageCount = Math.ceil((itemCount || 0) / table.getState().pagination.pageSize);
    const currentPageIndex = table.getState().pagination.pageIndex + 1;

    return (
        <Flex justify="space-between">
            <Flex flex={1} gap={1} align="center">
                <Text fontSize="sm">Page</Text>
                <Text fontSize="sm">{currentPageIndex}</Text>
                <Text fontSize="sm">of</Text>
                <Text fontSize="sm">{pageCount}</Text>
                <Icon as={BiX} />
                <Text fontSize="sm">{itemCount} total items</Text>
            </Flex>
            <Flex gap={2} align="center">
                <IconButton
                    aria-label="jump to first page"
                    icon={<Icon as={BiChevronsLeft} boxSize={5} />}
                    size="sm"
                    onClick={() => table.setPageIndex(0)}
                    isDisabled={currentPageIndex === 1}
                />
                <IconButton
                    aria-label="precious page"
                    icon={<Icon as={BiChevronLeft} boxSize={5} />}
                    size="sm"
                    onClick={() => table.previousPage()}
                    isDisabled={currentPageIndex === 1}
                />
                <IconButton
                    aria-label="next page"
                    icon={<Icon as={BiChevronRight} boxSize={5} />}
                    size="sm"
                    onClick={() => table.nextPage()}
                    isDisabled={currentPageIndex >= pageCount}
                />
                <IconButton
                    aria-label="jump to last page"
                    icon={<Icon as={BiChevronsRight} boxSize={5} />}
                    size="sm"
                    onClick={() => table.setPageIndex(pageCount - 1)}
                    isDisabled={currentPageIndex >= pageCount}
                />
            </Flex>
            <Flex flex={1} justify="flex-end" gap={4}>
                <Flex align="center" gap={1}>
                    <Text fontSize="sm" mr={1}>
                        Go to page
                    </Text>
                    <span>
                        <Input
                            width="80px"
                            size="sm"
                            type="number"
                            defaultValue={table.getState().pagination.pageIndex + 1}
                            onBlur={(e) => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                table.setPageIndex(page);
                            }}
                        />
                    </span>
                </Flex>
                <span>
                    <Select
                        size="sm"
                        value={table.getState().pagination.pageSize}
                        onChange={(e) => {
                            table.setPageSize(Number(e.target.value));
                        }}
                    >
                        {[1, 2, 4, 20, 40]
                            .map((multiplier) => multiplier * MIN_PAGE_SIZE)
                            .map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                    Show {pageSize}
                                </option>
                            ))}
                    </Select>
                </span>
            </Flex>
        </Flex>
    );
};
